import React from 'react';

function App() {
    return (
        <div>
            <h1>Welcome to Community Portal</h1>
Please visit our Passur login page or visit the PASSUR website to learn more about PASSUR.
For any questions, please reach out to customerservice@passur.com.
        </div>
    );
}

export default App;
